import React from 'react';
import {CheckIcon, Typography} from 'epic-ue-ui';
import {withLocalization} from '@epic-core/localization';
import styled from 'styled-components';
import {AccentColorOptions} from 'epic-ue-theme';

const Styled = styled.div`
    padding: 48px 32px 72px 32px;
    width: 100%;

    margin: auto;

    text-align: center;

    svg {
        width: auto;
        height: 40px;
    }

    .submitSuccessMsg.heading {
        margin-top: 10px;
    }
`;

export interface SubmitSuccessMessageProps {
    getMessage: (key: string) => string;
    submitSuccessfulMsg?: string;
    thankYouMsg?: string;
    accentColor?: AccentColorOptions;
}

const SubmitSuccessMessageComponent = ({
    getMessage,
    submitSuccessfulMsg = getMessage('epic.jobs.form.submitSuccess'),
    thankYouMsg = getMessage('epic.jobs.form.thankYou'),
    accentColor = 'sky'
}: SubmitSuccessMessageProps): JSX.Element => {
    return (
        <Styled>
            <CheckIcon fontSize={'large'} color={accentColor} />
            <Typography className="submitSuccessMsg" variant="h3">
                {submitSuccessfulMsg}
            </Typography>
            <Typography variant="p">{thankYouMsg}</Typography>
        </Styled>
    );
};

const SubmitSuccessMessage = withLocalization(SubmitSuccessMessageComponent);
export default SubmitSuccessMessage;
